var _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

const SvgCrown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.185,
    height: 11.43,
    viewBox: "0 0 15.185 11.43",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_52_49",
    "data-name": "Component 52 \\u2013 49",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M-4888.032,19800.248l1.744,6.816h10.411l1.53-6.816-3.22,1.662-3.676-4.775-3.351,4.775Z",
    transform: "translate(4888.032 -19797.135)",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_407",
    "data-name": "Line 407",
    transform: "translate(1.532 8.365)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M-4886.5,19805.348h11",
    transform: "translate(4888.032 -19797.135)",
    fill: "none",
    stroke: "#currentColor",
    strokeWidth: 1
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCrown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Crown.1cea5bb3.svg";
export { ForwardRef as ReactComponent };